import React, { useEffect, useState } from 'react'

export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };
  return (
    <header>
    <div id='menu' className='navbar-default navbar-fixed-top' >
      <div className='container'>
        <div className="row">
          <div className="col-md-3 col-sm-12">
            <div className="navbar-header"> <a href="/"><img src="img/logop201.png" alt="logo" /></a> </div>
          </div>
          <div className="col-md-9 col-sm-12">
            <div className="contact-details">
              <div className=" ">
                <div className="phonea"> <i className="fa fa-phone"></i>&nbsp;&nbsp;<a href="tel:01169269790 "> 01169269790 </a> </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </div>
    </header>
  )
}
